import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import DataJemaat from "../views/DataJemaat.vue";
import DataKeluarga from "../views/DataKeluarga.vue";
import DataAnggotaKeluarga from "../views/DataAnggotaKeluarga.vue";
import Signin from "../views/Signin.vue";
import Logout from "../views/Logout.vue";
import FormDataJemaat from "../views/FormDataJemaat.vue";
import AddDataKeluarga from "../views/AddDataKeluarga.vue";
import EditDataKeluarga from "../views/EditDataKeluarga.vue";
import ViewDataJemaat from "../views/ViewDataJemaat.vue";
import ViewDataKeluarga from "../views/ViewDataKeluarga.vue";
import EasyFind from "../views/EasyFind.vue";
import Laporan from "../views/Laporan.vue";
import store from "../store";

const routes = [{
        path: "/",
        name: "/",
        redirect: "/dashboard",
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { requiresLeader: true }
    },
    {
        path: "/laporan",
        name: "Laporan",
        component: Laporan,
    },
    {
        path: "/data-jemaat",
        name: "Data Jemaat",
        component: DataJemaat,
    },
    {
        path: "/data-jemaat/add",
        name: "Add Data Jemaat",
        component: FormDataJemaat,
        meta: { requiresAdmin: true }
    },
    {
        path: "/data-jemaat/edit/:id",
        name: "Edit Data Jemaat",
        component: FormDataJemaat,
        props: (route) => ({
            datas: route.params.datas,
            ...route.query
        }),
        meta: { requiresAdmin: true }
    },
    {
        path: "/data-jemaat/view/:id",
        name: "View Data Jemaat",
        component: ViewDataJemaat,
    },
    {
        path: "/data-keluarga",
        name: "Data Keluarga",
        component: DataKeluarga,
    },
    {
        path: "/data-keluarga/add",
        name: "Add Data Keluarga",
        component: AddDataKeluarga,
        meta: { requiresAdmin: true }
    },
    {
        path: "/data-keluarga/edit/:id",
        name: "Edit Data Keluarga",
        component: EditDataKeluarga,
        props: (route) => ({
            datas: route.params.datas,
            ...route.query
        }),
        meta: { requiresAdmin: true }
    },
    {
        path: "/data-keluarga/view/:id",
        name: "View Data Keluarga",
        component: ViewDataKeluarga,
    },
    {
        path: "/data-keluarga/anggota/:id",
        name: "Anggota Keluarga",
        component: DataAnggotaKeluarga,
        props: (route) => ({
            datas: route.params.datas,
            ...route.query
        })
    },
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
    },
    {
        path: "/easy-find",
        name: "Easy Find",
        component: EasyFind,
        meta: { requiresAdmin: true }
    },
    {
        path: "/logout",
        name: "Logout",
        component: Logout,
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    const user = store.state.user;
    if (to.meta.requiresAdmin && user && user.role !== 1) {
        next('/data-jemaat');
    } else if (to.meta.requiresLeader && user && ![1, 2, 3].includes(user.role)) {
        next('/data-jemaat');
    } else if (to.path === '/' && user && ![1, 2, 3].includes(user.role)) {
        next('/data-jemaat');
    } else {
        next();
    }
});

export default router;
